module.exports = __webpack_public_path__ + "img/icon-s1.6aaab99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/signStatistics/icon-s1.png
// module id = CBCK
// module chunks = 0 4 5 9